<div class="root" *transloco="let t; read: 'feature.news'">
    <div class="root__header">
        <div class="root__header__heading">{{ t("news") }}</div>
    </div>

    <ng-container *ngIf="news$ | async as news">
        <div class="root__news-list" *ngIf="news.length > 0">
            <ntf-news-list-item *ngFor="let newsItem of news" [news]="newsItem"></ntf-news-list-item>
        </div>

        <div *ngIf="!news || news.length <= 0" class="root__no-news">
            {{ t("noNews") }}
        </div>
    </ng-container>
</div>
